import { FC } from 'react';
import { makeStyles } from '@material-ui/core';
import UrlPrefixesSectionItem from '../UrlPrefixesSectionItem';

const useStyle = makeStyles({
  card: {
    border: '1px solid #CAD8FF',
    borderRadius: '8px',
    boxSizing: 'border-box',
    marginBottom: '32px',
    overflow: 'hidden'
  }
});

interface UrlPrefixesSectionProps {
  deepLinkPrefixes: string[];
  fallbackUrlPrefixes: string[];
  handleUpdateUrlPrefixes: (urlPrefixes: {
    deepLinkPrefixes?: string[];
    fallbackUrlPrefixes?: string[];
    shortLinkPrefixes?: string[];
  }) => void;
  shortLinkPrefixes: string[];
}

const UrlPrefixesSection: FC<UrlPrefixesSectionProps> = ({
  deepLinkPrefixes,
  fallbackUrlPrefixes,
  shortLinkPrefixes,
  handleUpdateUrlPrefixes
}) => {
  const classes = useStyle();

  return (
    <>
      <div className={classes.card}>
        <UrlPrefixesSectionItem
          handleUpdatePrefixes={(prefixes) => {
            handleUpdateUrlPrefixes({ shortLinkPrefixes: prefixes });
          }}
          prefixes={shortLinkPrefixes}
          urlType="short link"
        />

        <UrlPrefixesSectionItem
          handleUpdatePrefixes={(prefixes) => {
            handleUpdateUrlPrefixes({ deepLinkPrefixes: prefixes });
          }}
          prefixes={deepLinkPrefixes}
          urlType="deep link"
        />

        <UrlPrefixesSectionItem
          handleUpdatePrefixes={(prefixes) => {
            handleUpdateUrlPrefixes({ fallbackUrlPrefixes: prefixes });
          }}
          prefixes={fallbackUrlPrefixes}
          urlType="fallback"
        />
      </div>
    </>
  );
};

export default UrlPrefixesSection;
